import { Publish } from '@mui/icons-material';
import { green, grey, orange, red, yellow } from '@mui/material/colors';

import SituacaoIdDescricaoBase from './SituacaoIdDescricaoBase';

/**
 * Enum para situações de publicação de pauta.
 *
 * @readonly
 * @constant
 * @enum {Object.<string, Object>}
 */
// prettier-ignore
export const SITUACAO_PUBLICACAO_PAUTA = {
    NAO_LIBERADO_PUBLICACAO        : { id: 'NAO_LIBERADO_PUBLICACAO',        descricao: 'Não liberado para disponibilização',     cor: grey[600], corEditalCancelamento: grey[600] },
    LIBERADO_PARA_DISPONIBILIZACAO : { id: 'LIBERADO_PARA_DISPONIBILIZACAO', descricao: 'Liberado para disponibilização', cor: green[500], corEditalCancelamento: orange[500]   },
    AGUARDANDO_PROCESSAMENTO       : { id: 'AGUARDANDO_PROCESSAMENTO',       descricao: 'Aguardando processamento',               cor: yellow[600], corEditalCancelamento: yellow[600]  },
    EM_PROCESSAMENTO               : { id: 'EM_PROCESSAMENTO',               descricao: 'Em processamento',                       cor: yellow[600], corEditalCancelamento: grey[600]  },
    DISPONIBILIZADO_PARCIALMENTE   : { id: 'DISPONIBILIZADO_PARCIALMENTE',   descricao: 'Disponibilizado parcialmente',   cor: green[900], corEditalCancelamento: red[900]   },
    DISPONIBILIZADO                : { id: 'DISPONIBILIZADO',                descricao: 'Disponibilizado',                cor: green[900], corEditalCancelamento: orange[900]  },
    CANCELADO_PARCIALMENTE         : { id: 'CANCELADO_PARCIALMENTE',         descricao: 'Cancelado parcialmente',                 cor: orange[900], corEditalCancelamento: orange[900]  },
    CANCELADO                      : { id: 'CANCELADO',                      descricao: 'Cancelado',                              cor: red[700], corEditalCancelamento: red[700]     },
    ERRO_DE_PROCESSAMENTO          : { id: 'ERRO_DE_PROCESSAMENTO',          descricao: 'Erro de processamento',                  cor: red[900], corEditalCancelamento: red[900]     }
}

/**
 * @classdesc Facilita o acesso às propriedades e valores da enum.
 * @readonly
 */
export default class SituacaoPublicacaoPauta {
    static situacaoBase = new SituacaoIdDescricaoBase(SITUACAO_PUBLICACAO_PAUTA);
    static MSG_ERRO_IDENTIFICACAO_SITUACAO_PUBLICACAO_PAUTA =
        'Não foi possível identificar a situação da publicação da pauta.';

    static getDescricao(id) {
        return this.situacaoBase.getDescricao(id);
    }

    static getCor(id) {
        return this.situacaoBase.getValorPropriedade(id, 'cor');
    }

    static getCorEditalCancelamento(id) {
        return this.situacaoBase.getValorPropriedade(id, 'corEditalCancelamento');
    }

    static getIcone(id) {
        return <Publish sx={{ color: this.getCor(id), fillOpacity: '0.7' }} />;
    }
}
